// RazzAquatics — Recommendations Script
// File: assets/razza-recommendations.js
//
// Phase 6B.1: trust label + green Apply button colour.
// Bug 7 fix: type="button" on all rec card buttons.
//
// Issue 2 cache fix: _lastProducts / _lastSeedId prevent re-fetch on DOM rebuild.
//
// Issue 3 final fix (layout shift / late pop-in):
// snippets/razza-recommendations.liquid now pre-renders 4 skeleton cards in
// the track. The wrapper is visible from first paint (no .razza-rec--hidden
// when cart is non-empty). showSkeletons() is now a no-op when Liquid
// skeletons are already present — it only rebuilds when the track is empty
// or contains real cards that need to be replaced with skeletons.
// This means the recommendation area is always the correct height when the
// drawer opens, and real cards replace skeletons seamlessly.

window._razzaRecsLoaded = true;

(function () {
  'use strict';

  var MAX        = 10;
  var lastId     = null;
  var currentIdx = 0;
  var totalCards = 0;
  var autoTimer  = null;
  var AUTO_MS    = 3000;
  var collapsed  = false;
  var fetchingId = null;
  var activeCtrl = null;
  var loadFired  = false;

  var _lastProducts = null;
  var _lastSeedId   = null;

  function getWrap()   { return document.getElementById('razza-rec-wrp2');  }
  function getTrack()  { return document.getElementById('razza-rec-trk2');  }
  function getBody()   { return document.getElementById('razza-rec-bdy2');  }
  function getToggle() { return document.getElementById('razza-rec-tgl2');  }
  function getPrev()   { return document.getElementById('razza-rec-prv2');  }
  function getNext()   { return document.getElementById('razza-rec-nxt2');  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function getCardWidth() {
    var track = getTrack();
    if (!track || !track.firstElementChild) return 122;
    var gap = parseFloat(getComputedStyle(track).gap || '10') || 10;
    return track.firstElementChild.offsetWidth + gap;
  }

  // ── Carousel ─────────────────────────────────────────────────────────────
  function goTo(idx) {
    var track = getTrack();
    if (!track) return;
    var cardW   = getCardWidth();
    var visible = cardW > 0 ? Math.max(1, Math.floor(track.parentElement.offsetWidth / cardW)) : 3;
    var max     = Math.max(0, totalCards - visible);
    currentIdx  = Math.max(0, Math.min(idx, max));
    track.style.transform = 'translateX(-' + (currentIdx * cardW) + 'px)';
    var prev = getPrev(); if (prev) prev.disabled = currentIdx === 0;
    var next = getNext(); if (next) next.disabled = currentIdx >= max;
  }

  function stopAuto() { clearInterval(autoTimer); autoTimer = null; }

  function resetAuto() {
    stopAuto();
    if (collapsed || totalCards <= 3) return;
    autoTimer = setInterval(function () {
      goTo(currentIdx + 1 > Math.max(0, totalCards - 3) ? 0 : currentIdx + 1);
    }, AUTO_MS);
  }

  // ── Skeletons ────────────────────────────────────────────────────────────
  // Issue 3 fix: if the track already has .razza-rec__skeleton children
  // (pre-rendered by Liquid), skip the clear+rebuild. This preserves the
  // layout space that Liquid reserved and avoids the layout shift that
  // occurred when JS removed hidden, injected skeletons, and painted cards.
  function showSkeletons() {
    var wrap  = getWrap();
    var track = getTrack();
    if (!wrap || !track) return;

    // If Liquid skeletons are already present, just ensure wrap is visible.
    if (track.querySelector('.razza-rec__skeleton') &&
        !track.querySelector('.razza-rec__card')) {
      wrap.classList.remove('razza-rec--hidden');
      return;
    }

    // Otherwise build skeletons from scratch (e.g. replacing real cards).
    stopAuto();
    track.style.transition = 'none';
    track.style.transform  = 'translateX(0)';
    track.innerHTML = '';
    for (var i = 0; i < 4; i++) {
      var s = document.createElement('div');
      s.className = 'razza-rec__skeleton';
      s.setAttribute('aria-hidden', 'true');
      s.innerHTML = '<div class="razza-rec__skel-img"></div>' +
                    '<div class="razza-rec__skel-line"></div>' +
                    '<div class="razza-rec__skel-line razza-rec__skel-line--short"></div>';
      track.appendChild(s);
    }
    wrap.classList.remove('razza-rec--hidden');
  }

  // ── Render cards ──────────────────────────────────────────────────────────
  function renderCards(products, retries) {
    var wrap  = getWrap();
    var track = getTrack();
    stopAuto();
    currentIdx = 0;

    if (!track) {
      retries = retries || 0;
      if (retries < 5) setTimeout(function () { renderCards(products, retries + 1); }, 100);
      return;
    }

    track.style.transition = 'none';
    track.style.transform  = 'translateX(0)';
    track.innerHTML = '';

    if (!products || !products.length) {
      totalCards = 0;
      if (wrap) wrap.classList.add('razza-rec--hidden');
      return;
    }

    totalCards = products.length;
    if (wrap) wrap.classList.remove('razza-rec--hidden');

    products.forEach(function (p) {
      var v         = p.variants[0];
      var imgSrc    = p.featured_image ? p.featured_image + '&width=240' : '';
      var compare   = v.compare_at_price;
      var price     = v.price;
      var priceHTML = (compare && compare > price)
        ? '<s>' + money(compare) + '</s> ' + money(price)
        : money(price);

      var card = document.createElement('div');
      card.className = 'razza-rec__card';
      card.innerHTML = [
        '<a href="' + p.url + '" class="razza-rec__card-img">',
          imgSrc ? '<img src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '',
        '</a>',
        '<a href="' + p.url + '" class="razza-rec__card-title">' + p.title + '</a>',
        '<div class="razza-rec__card-price">' + priceHTML + '</div>',
        '<div class="razza-rec__card-trust">' +
          (v.available ? '\u2713 Ships with your order' : '') +
        '</div>',
        '<button type="button" class="razza-rec__card-btn" data-variant="' + v.id + '" data-product="' + p.id + '"' + (v.available ? '' : ' disabled') + '>',
          v.available ? 'Add to Cart' : 'Sold Out',
        '</button>',
      ].join('');
      track.appendChild(card);
    });

    requestAnimationFrame(function () {
      var t = getTrack();
      if (t) { t.style.transition = ''; goTo(0); }
      resetAuto();
    });
  }

  // ── Fetch recommendations ──────────────────────────────────────────────────
  function fetchRecs(productId) {
    if (!productId) return;
    if (productId === lastId && totalCards > 0) {
      var wrap = getWrap();
      if (wrap) wrap.classList.remove('razza-rec--hidden');
      return;
    }
    if (productId === fetchingId) return;
    if (activeCtrl) { try { activeCtrl.abort(); } catch(e) {} }
    var ctrl = new AbortController();
    activeCtrl = ctrl;
    fetchingId = productId; lastId = productId; totalCards = 0;
    showSkeletons();
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + MAX + '&intent=related', {
      credentials: 'same-origin', signal: ctrl.signal,
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (ctrl !== activeCtrl) return;
        activeCtrl = null; fetchingId = null;
        _lastProducts = d.products;
        _lastSeedId   = productId;
        renderCards(d.products);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        activeCtrl = null; fetchingId = null; lastId = null;
        var wrap = getWrap();
        // On error, leave Liquid skeletons in place rather than hiding the area
        // (avoids layout shift). Cards will show on next open if cart still has items.
        if (wrap && !wrap.querySelector('.razza-rec__skeleton')) {
          wrap.classList.add('razza-rec--hidden');
        }
      });
  }

  // ── Load from cart ──────────────────────────────────────────────────────
  function loadFromCart(retries) {
    if (loadFired && !retries) return;
    loadFired = true;
    setTimeout(function () { loadFired = false; }, 800);
    retries = retries || 0;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          var wrap = getWrap();
          if (wrap) wrap.classList.add('razza-rec--hidden');
          return;
        }
        var wrap = getWrap();
        if (!wrap) {
          if (retries < 3) setTimeout(function () { loadFromCart(retries + 1); }, 200);
          return;
        }
        fetchRecs(cart.items[cart.items.length - 1].product_id);
      })
      .catch(function () {
        // On cart fetch error, leave skeletons in place
      });
  }

  // ── Add to cart from rec card ────────────────────────────────────────────
  function addToCartFromRec(btn) {
    var variantId = btn.dataset.variant;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Content-Type', 'application/json');
    var xhrDone = false;

    xhr.onload = function () {
      if (xhrDone) return; xhrDone = true;
      try {
        var data = JSON.parse(xhr.responseText);
        if (data.id) {
          btn.textContent = 'Added \u2713';
          btn.style.background = '#3a9200';
          if (window.razzaDeliveryDate) {
            window.razzaDeliveryDate.refresh({ patchAll: true });
          } else {
            if (window.razzaDiscount)    { window.razzaDiscount.refresh(); }
            if (window.razzaShippingBar) { window.razzaShippingBar.refresh(); }
          }
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
            btn.style.background = '';
          }, 2000);
        } else {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }
      } catch (e) {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
    };

    xhr.onerror = function () { btn.disabled = false; btn.textContent = 'Add to Cart'; };
    xhr.send(JSON.stringify({ id: parseInt(variantId), quantity: 1 }));
  }

  // ── Event delegation ────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (!e.target) return;
    if (e.target.closest && e.target.closest('#razza-rec-prv2')) { stopAuto(); goTo(currentIdx - 1); return; }
    if (e.target.closest && e.target.closest('#razza-rec-nxt2')) { stopAuto(); goTo(currentIdx + 1); return; }
    if (e.target.closest && e.target.closest('#razza-rec-tgl2')) {
      collapsed = !collapsed;
      var tog = getToggle(); var body = getBody();
      if (tog)  tog.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      if (body) body.classList.toggle('razza-rec__body--collapsed', collapsed);
      collapsed ? stopAuto() : resetAuto();
      return;
    }
    var addBtn = e.target.closest && e.target.closest('.razza-rec__card-btn');
    if (addBtn && !addBtn.disabled) { addToCartFromRec(addBtn); return; }
  });

  // ── Patch discount Apply button to Razz green ───────────────────────────
  function patchApplyBtn() {
    var applyBtn = document.getElementById('razza-disc-btn');
    if (applyBtn && applyBtn.style.background !== 'rgb(92, 184, 0)') {
      applyBtn.style.setProperty('background', '#5CB800', 'important');
      applyBtn.style.setProperty('color', '#ffffff', 'important');
      applyBtn.style.setProperty('border-color', '#5CB800', 'important');
    }
  }

  patchApplyBtn();
  new MutationObserver(function () { patchApplyBtn(); })
    .observe(document.body, { childList: true, subtree: true });

  // ── DOM rebuild detection ───────────────────────────────────────────────────
  var lastWrapEl    = null;
  var schedDebounce = null;

  function scheduleLoad() {
    if (window._razzaUpdating) return;
    clearTimeout(schedDebounce);
    schedDebounce = setTimeout(function () {
      var wrap = getWrap();
      if (wrap && wrap !== lastWrapEl) {
        lastWrapEl = wrap;
        var t = getTrack();
        if (t) { t.style.transition = 'none'; t.style.transform = 'translateX(0)'; }
        currentIdx = 0;

        if (_lastProducts && _lastSeedId && _lastSeedId === lastId && _lastProducts.length > 0) {
          // Same product, cached recs available — render immediately.
          totalCards = _lastProducts.length;
          renderCards(_lastProducts);
          // Background re-sync after 2s.
          setTimeout(function () {
            var seedForBg = _lastSeedId;
            fetch('/recommendations/products.json?product_id=' + seedForBg + '&limit=' + MAX + '&intent=related', {
              credentials: 'same-origin'
            })
              .then(function (r) { return r.json(); })
              .then(function (d) {
                if (_lastSeedId === seedForBg && d.products && d.products.length) {
                  _lastProducts = d.products;
                  renderCards(d.products);
                }
              })
              .catch(function () {});
          }, 2000);
        } else {
          // New product or no cache — fresh fetch.
          // Liquid skeletons are already in DOM so no layout shift.
          lastId = null;
          loadFromCart();
        }
      } else if (!wrap && lastWrapEl) {
        lastWrapEl = null; totalCards = 0; lastId = null;
        stopAuto();
      }
    }, 0);
  }

  var cdEl = document.querySelector('cart-drawer');
  if (cdEl) new MutationObserver(scheduleLoad).observe(cdEl, { childList: true, subtree: false });

  var cdDiv = document.getElementById('CartDrawer');
  if (cdDiv) new MutationObserver(scheduleLoad).observe(cdDiv, { childList: true, subtree: false });

  // ── Cart events ─────────────────────────────────────────────────────────────
  ['cart:updated', 'theme:cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (window._razzaUpdating) return;
      var cart = e.detail && (e.detail.cart || e.detail);
      if (cart && cart.items && cart.items.length) {
        var seed = cart.items[cart.items.length - 1].product_id;
        if (seed && seed !== lastId) { lastId = null; fetchRecs(seed); }
      }
    });
  });

  // ── Init ────────────────────────────────────────────────────────────────────
  loadFromCart();
  window.razzaRecs = {
    refresh: function () {
      lastId = null; _lastProducts = null; _lastSeedId = null; loadFired = false;
      loadFromCart();
    }
  };

})();
